import { RouteConfig } from '@abaco/web-common/src/app';

const routes: RouteConfig[] = [
    {
        name: 'process-list',
        path: '/processes',
        component: () => import("./views/list/indexWrapper.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "process-years-select-navbar-item"] }
    },
    {
        name: 'management-process-list',
        path: '/management-processes',
        component: () => import("./views/list/indexWrapper.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "process-years-select-navbar-item"] },
        props: { filter: 'MANAGE' }
    },
    {
        name: 'engage-process-list',
        path: '/engage-processes',
        component: () => import("./views/list/indexWrapper.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "process-years-select-navbar-item"] },
        props: { filter: 'ENGAGE' }
    },
    {
        name: 'precontract-process-list',
        path: '/precontract-processes',
        component: () => import("./views/list/indexWrapper.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "process-years-select-navbar-item"] },
        props: { filter: 'PRECON' }
    },
    {
        name: 'inspection-list',
        path: '/inspections',
        component: () => import("./views/inspectionList/indexWrapper.vue"),
        meta: { navbarItems: ["process-years-select-navbar-item"] }
    },
    {
        name: "process-detail",
        path: "/processes/:process_id",
        component: () => import("./views/detail/indexWrapper.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}, "process-years-select-navbar-item"] },
    },
    {
        name: 'processes-old',
        path: '/processes-old',
        component: () => import("./views/OldProcessesIframeContainer.vue"),
        props: { isFarmRequired:false }
    },
    {
        name: 'processes-old-subject',
        path: '/processes-old-subject',
        component: () => import("./views/OldProcessesIframeContainer.vue"),
        meta: { navbarItems: [{component: 'farm-select-nav-bar-item', props: {isRequired: true}}] },
        props: { isFarmRequired: true }
    },
];

export default routes;
